exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.incorporacionAbandono tr:not(.disabled):hover {\r\n  cursor: pointer;\n}\n.incorporacionAbandono tr.selected,\r\n.incorporacionAbandono tr:hover {\r\n  background-color: var(--gris-medio);\n}\n.incorporacionAbandono tr.disabled {\r\n  color: var(--gris-medio);\r\n  background-color: var(--gris-claro);\n}\r\n", ""]);

// exports
